import { globalStyObj } from '@/assets/packageAssets/allStyleConfigs/a-global-cfg.js'

import { echoStyObj } from '@/assets/packageAssets/allStyleConfigs/echo.cfg.js'
import { joychatStyObj } from '@/assets/packageAssets/allStyleConfigs/joychat.cfg.js'
import { kikoStyObj } from '@/assets/packageAssets/allStyleConfigs/kiko.cfg.js'
import { vavaStyObj } from '@/assets/packageAssets/allStyleConfigs/vava.cfg.js'
import { vibeoStyObj } from '@/assets/packageAssets/allStyleConfigs/vibeo.cfg.js'

const styObj = {
  default: {
    ...vibeoStyObj,
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`
  },
  echo: {
    ...echoStyObj,
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`
  },
  joychat: {
    ...joychatStyObj,
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`
  },
  kiko: {
    ...kikoStyObj,
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`
  },
  vava: {
    ...vavaStyObj,
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`
  },
  vibeo: {
    ...vibeoStyObj,
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`
  }
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return { ...globalStyObj, ...styObj[this.packageName] }
        }
        // 未配置
        else {
          return { ...globalStyObj, ...styObj['default'] }
        }
      }
      return {}
    }
  }
}
